export const API_URL = "https://port-0-movie-server2-6g2llf6iizh7.sel3.cloudtype.app";

/* export const API_URL = "http://localhost:8080"; */